import BaseModel from '../core/BaseModel'
export default class ImportDataProcessingModel extends BaseModel {
    constructor() {
        super({ 
                name: "import_data_processing",
                tableName: 'import_data_processing'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            }
        },)
    }

}